import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";

import { oauthActions } from "../_actions/oauth.actions";

const OauthAuthorize = ({ t }) => {
    const dispatch = useDispatch();
    const oauth = useSelector((state) => state.oauth);
    const auth = useSelector((state) => state.auth);

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = (evt) => {
        evt.preventDefault();

        if (submitted) {
            return;
        }

        setSubmitted(true);
        dispatch(oauthActions.consent(oauth.flowId));
    };

    useEffect(() => {
        if (auth.error) {
            setError(auth.error);
            setSubmitted(false);
        } else {
            setError("");
        }
    }, [auth.error]);

    if (!oauth) {
        return <div>{t("OAUTH.LOADING")}</div>;
    }

    return (
        <div className="aph oauth__modal">
            <div className="aph oauth__modal__header">
                <p className="aph">{t("OAUTH.SHARING_WITH")}</p>
                {!!oauth.clientName && (
                    <h3 className="aph oauth__modal__header__name">
                        {oauth.clientName}
                    </h3>
                )}
            </div>

            {oauth.scopes.includes("profile") && (
                <p>{t("OAUTH.PROFILE_CONSENT")}</p>
            )}
            <p>
                {t("OAUTH.TERMS.PREFIX")}
                <a href="https://sobre.ingresse.com/termos-de-privacidade">
                    {t("OAUTH.TERMS.PRIVACY")}
                </a>
                {t("OAUTH.TERMS.CONCAT")}
                <a href="https://sobre.ingresse.com/termos-de-servico">
                    {t("OAUTH.TERMS.SERVICE")}
                </a>
                {t("OAUTH.TERMS.SUFFIX")}
            </p>
            <button
                className={`aph btn btn--block btn--primary`}
                type="button"
                onClick={handleSubmit}
                disabled={submitted}
            >
                {t("OAUTH.ALLOW")}
            </button>
        </div>
    );
};

export default withTranslation()(OauthAuthorize);
